export default class extends Controller {

  toggle(event) {
    event && event.preventDefault();
    this.active = !this.active;
  }

  openToggle(event) {
    event && event.preventDefault();
    this.active = true;
  }

  closeToggle(event) {
    event && event.preventDefault();
    this.active = false;
  }

  //
  // INTERNAL USE
  //

  toggleClasses() {
    const action = this.active ? 'add' : 'remove';
    this.element.classList[action]('active');
    this.navigationContainer.classList[action]('nav-active');
  }

  //
  // GETTERS AND SETTERS
  //

  get active() {
    return !!this.data.get('active');
  }

  set active(isActive) {
    this.data.set('active', isActive ? '1' : '');
    this.toggleClasses();
  }

  get navigationContainer() {
    return document.querySelector('#nav--top-right');
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/navigation-toggle-controller.js